import Vue from 'vue';
import Router from 'vue-router';
import Template from '@/views/Template';
import store from './store';
import axios from 'axios';
import permission from './permission';
import jsonwebtoken from 'jsonwebtoken';

Vue.use(Router);
let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // public -- allow not authenticate
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/access-denied',
      name: 'accessDenied',
      component: () => import(/* webpackChunkName: "404" */ './views/AccessDenied.vue')
    },
    {
      path: '/landing/:appid/:versionid',
      name: 'appsLanding',
      component: () => import(/* webpackChunkName: "applanding" */ './views/appstore/AppLanding.vue')
    },
    {
      path: '/landing2/:appid',
      name: 'appsLanding2',
      component: () => import(/* webpackChunkName: "applanding" */ './views/appstore2/AppLanding.vue')
    },
    {
      path: '/landing2/:appid/:versionid',
      name: 'appsLanding2withVersion',
      component: () => import(/* webpackChunkName: "applanding" */ './views/appstore2/AppLanding.vue')
    },
    {
      path: '/landing-download/:appid/:versionid/:token',
      name: 'appsLandingDownload',
      component: () => import(/* webpackChunkName: "appLandingDownload" */ './views/appstore2/Download.vue')
    },
    {
      path: '/service-requests/:id',
      name: 'requestLanding',
      meta: { requiresAuth: false },
      component: () => import(/* webpackChunkName: "requestLanding" */ './views/oneapp/service-request/LandingPage.vue')
    },
    // private require authenticate
    {
      path: '/',
      name: 'home',
      redirect: '/home',
      component: Template,
      children: [ // views with template
        {
          path: 'home',
          name: '',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
        },
        {
          path: 'about',
          name: 'about',
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
          path: 'news/',
          name: 'news',
          redirect: { name: 'news-home' },
          meta: {
            requiresAuth: true,
            permission: permission.admin101
          },
          component: () => import(/* webpackChunkName: "about" */ './views/news/NewsTemplate.vue'),
          children: [
            {
              path: 'home',
              name: 'news-home',
              meta: { label: 'home' },
              component: () => import(/* webpackChunkName: "about" */ './views/news/Home.vue')
            },
            {
              path: 'create',
              name: 'news-create',
              meta: { label: 'create' },
              component: () => import(/* webpackChunkName: "about" */ './views/news/FormNews.vue')
            },
            {
              path: ':id',
              name: 'news-details',
              meta: { label: 'details' },
              component: () => import(/* webpackChunkName: "about" */ './views/news/FormNews.vue')
            }
          ]
        },
        {
          path: 'privilege/',
          name: 'privilege',
          redirect: { name: 'privilege-home' },
          meta: {
            requiresAuth: true,
            permission: permission.admin101
          },
          component: () => import(/* webpackChunkName: "about" */ './views/privilege/PrivilegeTemplate.vue'),
          children: [
            {
              path: 'home',
              name: 'privilege-home',
              meta: { label: 'home' },
              component: () => import(/* webpackChunkName: "about" */ './views/privilege/Home.vue')
            },
            {
              path: 'create',
              name: 'privilege-create',
              meta: { label: 'create' },
              component: () => import(/* webpackChunkName: "about" */ './views/privilege/FormPrivilege.vue')
            },
            {
              path: ':id',
              name: 'privilege-details',
              meta: { label: 'details' },
              component: () => import(/* webpackChunkName: "about" */ './views/privilege/FormPrivilege.vue')
            }
          ]
        },
        {
          path: 'reward/',
          name: 'reward',
          redirect: { name: 'reward-home' },
          meta: {
            requiresAuth: true,
            permission: permission.admin101
          },
          component: () => import(/* webpackChunkName: "rewardTemplate" */ './views/reward/RewardTemplate.vue'),
          children: [
            {
              path: 'home',
              name: 'reward-home',
              meta: { label: 'home' },
              component: () => import(/* webpackChunkName: "rewardHome" */ './views/reward/Home.vue')
            },
            {
              path: 'create',
              name: 'reward-create',
              meta: { label: 'create' },
              component: () => import(/* webpackChunkName: "rewardCreate" */ './views/reward/FormReward.vue')
            },
            {
              path: ':id',
              name: 'reward-details',
              meta: { label: 'details' },
              component: () => import(/* webpackChunkName: "rewardDetails" */ './views/reward/FormReward.vue')
            }
          ]
        },
        {
          path: 'base/',
          name: 'base',
          redirect: { name: 'home' },
          meta: {
            requiresAuth: true,
            permission: permission.admin101
          },
          component: () => import(/* webpackChunkName: "baseTemplate" */ './views/base/BaseTemplate.vue'),
          children: [
            {
              path: 'shop/',
              name: 'shop',
              redirect: { name: '101shops-home' },
              component: () => import(/* webpackChunkName: "baseTemplate" */ './views/base/BaseTemplate.vue'),
              children: [
                {
                  path: 'home',
                  name: '101shops-home',
                  meta: { label: 'home' },
                  component: () => import(/* webpackChunkName: "shopHome" */ './views/base/Shop.vue')
                },
                {
                  path: 'create',
                  name: '101shops-create',
                  meta: { label: 'create' },
                  component: () => import(/* webpackChunkName: "shopCreate" */ './views/base/FormShop.vue')
                },
                {
                  path: 'details/:id',
                  name: '101shops-details',
                  meta: { label: 'details' },
                  component: () => import(/* webpackChunkName: "shopDetails" */ './views/base/FormShop.vue')
                }
              ]
            },
            {
              path: 'zone/',
              name: 'zone',
              redirect: { name: '101zones-home' },
              component: () => import(/* webpackChunkName: "baseTemplate" */ './views/base/BaseTemplate.vue'),
              children: [
                {
                  path: 'home',
                  name: '101zones-home',
                  meta: { label: 'home' },
                  component: () => import(/* webpackChunkName: "zoneHome" */ './views/base/Zone.vue')
                },
                {
                  path: 'create',
                  name: '101zones-create',
                  meta: { label: 'create' },
                  component: () => import(/* webpackChunkName: "zoneCreate" */ './views/base/FormZone.vue')
                },
                {
                  path: 'details/:id',
                  name: '101zones-details',
                  meta: { label: 'details' },
                  component: () => import(/* webpackChunkName: "zoneDetails" */ './views/base/FormZone.vue')
                }
              ]
            },
            {
              path: 'floor/',
              name: 'floor',
              redirect: { name: '101floors-home' },
              component: () => import(/* webpackChunkName: "floorTemplate" */ './views/base/BaseTemplate.vue'),
              children: [
                {
                  path: 'home',
                  name: '101floors-home',
                  meta: { label: 'home' },
                  component: () => import(/* webpackChunkName: "floorHome" */ './views/base/Floor.vue')
                },
                {
                  path: 'create',
                  name: '101floors-create',
                  meta: { label: 'create' },
                  component: () => import(/* webpackChunkName: "floorCreate" */ './views/base/FormFloor.vue')
                },
                {
                  path: 'details/:id',
                  name: '101floors-details',
                  meta: { label: 'details' },
                  component: () => import(/* webpackChunkName: "floorDetails" */ './views/base/FormFloor.vue')
                }
              ]
            },
            {
              path: 'category/',
              name: 'category',
              redirect: { name: '101categories-home' },
              component: () => import(/* webpackChunkName: "categoryTemplate" */ './views/base/BaseTemplate.vue'),
              children: [
                {
                  path: 'home',
                  name: '101categories-home',
                  meta: { label: 'home' },
                  component: () => import(/* webpackChunkName: "categoryHome" */ './views/base/Category.vue')
                },
                {
                  path: 'create',
                  name: '101categories-create',
                  meta: { label: 'create' },
                  component: () => import(/* webpackChunkName: "categoryCreate" */ './views/base/FormCategory.vue')
                },
                {
                  path: 'details/:id',
                  name: '101categories-details',
                  meta: { label: 'details' },
                  component: () => import(/* webpackChunkName: "categoryDetails" */ './views/base/FormCategory.vue')
                }
              ]
            }
          ]
        },
        {
          path: 'summary/',
          name: 'summary',
          redirect: { name: 'summary-home' },
          meta: {
            requiresAuth: true,
            permission: permission.admin101
          },
          component: () => import(/* webpackChunkName: "about" */ './views/summary/SummaryTemplate.vue'),
          children: [
            {
              path: 'home',
              name: 'summary-home',
              meta: { label: 'home' },
              component: () => import(/* webpackChunkName: "about" */ './views/summary/Home.vue')
            }
          ]
        },
        {
          path: 'one-app/',
          name: 'one-app',
          redirect: { name: 'home' },
          meta: {
            requiresAuth: true,
            permission: permission.adminOneApp
          },
          component: () => import(/* webpackChunkName: "oneapp" */ './views/oneapp/OneAppTemplate.vue'),
          children: [
            {
              path: 'announcement/',
              name: 'announcement',
              redirect: { name: 'announcement-home' },
              component: () => import(/* webpackChunkName: "oneapp" */ './views/oneapp/OneAppTemplate.vue'),
              children: [
                {
                  path: 'home',
                  name: 'announcement-home',
                  meta: { label: 'home', permission: permission.adminOneApp },
                  component: () => import(/* webpackChunkName: "announcementHome" */ './views/oneapp/announcement/Home.vue')
                },
                {
                  path: 'create',
                  name: 'announcement-create',
                  meta: { label: 'create', permission: permission.adminOneApp },
                  component: () => import(/* webpackChunkName: "announcementCreate" */ './views/oneapp/announcement/FormAnnouncement.vue')
                },
                {
                  path: 'details/:id',
                  name: 'announcement-details',
                  meta: { label: 'details', permission: permission.adminOneApp },
                  component: () => import(/* webpackChunkName: "announcementDetails" */ './views/oneapp/announcement/FormAnnouncement.vue')
                }
              ]
            },
            {
              path: 'profiles',
              name: 'one_app_profiles',
              redirect: { name: 'one_app_profiles-home' },
              component: () => import('./views/oneapp/OneAppTemplate.vue'),
              children: [
                {
                  path: '',
                  name: 'one_app_profiles-home',
                  meta: { label: 'home' },
                  component: () => import('./views/oneapp/UserProfiles.vue')
                },
                {
                  path: ':id/profile',
                  name: 'one_app_profiles-profile',
                  meta: { label: 'profile' },
                  props: true,
                  component: () => import('./views/oneapp/UserProfile.vue')
                },
                {
                  path: ':id/profile/project/',
                  name: 'one_app_profiles-project',
                  meta: { label: 'Add Project to User' },
                  props: true,
                  component: () => import('./views/oneapp/Project.vue')
                },
                {
                  path: ':id/profile/project/:projectcode/unit',
                  name: 'one_app_profiles-unit',
                  meta: { label: 'Add Unit to User' },
                  props: true,
                  component: () => import('./views/oneapp/Unit.vue')
                }
              ]
            },
            {
              path: 'residents',
              name: 'one_app_residents',
              meta: { label: 'residents' },
              redirect: { name: 'one_app_residents-residents' },
              component: () => import('./views/oneapp/OneAppTemplate.vue'),
              children: [
                {
                  path: '',
                  name: 'one_app_residents-residents',
                  meta: { label: 'Home' },
                  component: () => import('./views/oneapp/Residents.vue')
                },
                {
                  path: 'new',
                  name: 'one_app_residents-add',
                  meta: { label: 'Add Resident' },
                  component: () => import('./views/oneapp/Resident.vue')
                },
                {
                  path: 'import',
                  name: 'one_app_residents-import',
                  meta: { label: 'Import' },
                  component: () => import('./views/oneapp/Excel.vue')
                },
                {
                  path: ':id/resident',
                  name: 'one_app_residents-edit',
                  meta: { label: 'Edit Resident' },
                  props: true,
                  component: () => import('./views/oneapp/Resident.vue')
                },
                {
                  path: ':id/resident/project/',
                  name: 'one_app_residents-project',
                  meta: { label: 'Add Project to Resident' },
                  props: true,
                  component: () => import('./views/oneapp/Project.vue')
                },
                {
                  path: ':id/resident/project/:projectcode/unit',
                  name: 'one_app_residents-unit',
                  meta: { label: 'Add Unit to Resident' },
                  props: true,
                  component: () => import('./views/oneapp/UnitResident.vue')
                },
                {
                  path: ':id/resident/project/:projectcode/unit/:unitId/edit',
                  name: 'one_app_residents-unit-edit',
                  meta: { label: 'Edit Unit to Resident' },
                  props: true,
                  component: () => import('./views/oneapp/UnitResident.vue')
                }
              ]
            },
            {
              path: 'projects',
              name: 'one_app_projects',
              meta: { label: 'projects' },
              redirect: { name: 'one_app_projects-projects' },
              component: () => import('./views/oneapp/OneAppTemplate.vue'),
              children: [
                {
                  path: '',
                  name: 'one_app_projects-projects',
                  meta: { label: 'home' },
                  component: () => import('./views/oneapp/Projects.vue')
                },
                {
                  path: 'new',
                  name: 'one_app_projects-project-new',
                  meta: { label: 'add project' },
                  props: true,
                  component: () => import('./views/oneapp/ProjectForm.vue')
                },
                {
                  path: ':code',
                  name: 'one_app_projects-project',
                  meta: { label: 'project' },
                  props: true,
                  component: () => import('./views/oneapp/ProjectForm.vue')
                }
              ]
            },
            {
              path: 'messaging/',
              name: 'one_app_messaging',
              redirect: { name: 'one_app_messaging-home' },
              component: () => import(/* webpackChunkName: "oneapp" */ './views/oneapp/OneAppTemplate.vue'),
              children: [
                {
                  path: 'home',
                  name: 'one_app_messaging-home',
                  meta: { label: 'home', permission: permission.adminOneApp },
                  component: () => import(/* webpackChunkName: "messaging-home" */ './views/oneapp/messaging/FormMessaging.vue')
                },
                {
                  path: 'setting',
                  name: 'one_app_messaging-setting',
                  meta: { label: 'setting', permission: permission.adminOneApp },
                  component: () => import(/* webpackChunkName: "messaging-setting" */ './views/oneapp/messaging/FormSetting.vue')
                },
                {
                  path: 'history',
                  name: 'one_app_messaging-history',
                  meta: { label: 'history', permission: permission.adminOneApp },
                  component: () => import(/* webpackChunkName: "messaging-history" */ './views/oneapp/messaging/History.vue')
                }
              ]
            },
            {
              path: 'service-request/',
              name: 'one_app_service-request',
              redirect: { name: 'one_app_service-request-home' },
              component: () => import(/* webpackChunkName: "oneapp" */ './views/oneapp/OneAppTemplate.vue'),
              children: [
                {
                  path: 'home',
                  name: 'one_app_service-request-home',
                  meta: { label: 'home', permission: permission.adminOneApp },
                  component: () => import(/* webpackChunkName: "service-request-home" */ './views/oneapp/service-request/Home.vue')
                }
              ]
            }
          ]
        },
        {
          path: 'docs/',
          name: 'docs',
          redirect: { name: 'docs-home' },
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "about" */ './views/docs/DocsTemplate.vue'),
          children: [
            {
              path: 'home',
              name: 'docs-home',
              meta: { label: 'home' },
              component: () => import(/* webpackChunkName: "about" */ './views/docs/Home.vue')
            },
            {
              path: 'create',
              name: 'docs-create',
              meta: { label: 'create', permission: permission.writer },
              component: () => import(/* webpackChunkName: "about" */ './views/docs/CreateDocument.vue')
            },
            {
              path: ':id',
              name: 'docs-content',
              meta: { label: 'content' },
              component: () => import(/* webpackChunkName: "about" */ './views/docs/Content.vue')
            }
          ]
        },
        {
          path: 'gateway/',
          name: 'home-automation',
          meta: {
            requiresAuth: true
          },
          component: () => import('./views/gateway/Home.vue')
        },
        {
          path: 'envs/',
          name: 'envs',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "about" */ './views/envs/Home.vue')
        },
        { /* AppStore */
          path: 'apps/',
          name: 'apps',
          redirect: { name: 'apps-home' },
          meta: {
            label: 'apps',
            requiresAuth: true,
            permission: permission.appStore
          },
          component: () => import(/* webpackChunkName: "appsHome" */ './views/appstore/AppStoreTemplate.vue'),
          children: [
            {
              path: '',
              name: 'apps-home',
              meta: { label: 'home', permission: permission.appStore },
              component: () => import('./views/appstore/Home.vue')
            },
            {
              path: 'create',
              name: 'apps-create',
              meta: { label: 'Create New App', permission: permission.appStore },
              component: () => import('./views/appstore/AppForm.vue')
            },
            {
              path: ':id',
              name: 'apps-details',
              redirect: { name: 'apps-details-home' },
              meta: { label: 'appdetailname', permission: permission.appStore },
              component: () => import('./views/appstore/AppStoreTemplate.vue'),
              children: [
                {
                  path: '',
                  name: 'apps-details-home',
                  meta: { label: 'appdetails', permission: permission.appStore },
                  component: () => import('./views/appstore/AppDetail.vue')
                },
                {
                  path: 'newversion',
                  name: 'apps-version',
                  meta: { label: 'Add Version', permission: permission.appStore },
                  component: () => import('./views/appstore/VersionForm.vue')
                },
                {
                  path: 'editversion/:versionid',
                  name: 'app-version-edit',
                  meta: { label: 'Edit Version', permission: permission.appStore },
                  component: () => import(/* webpackChunkName: "about" */ './views/appstore/VersionForm.vue')
                },
                {
                  path: 'edit',
                  name: 'apps-edit',
                  meta: { label: 'Edit Application Information', permission: permission.appStore },
                  component: () => import('./views/appstore/AppForm.vue')
                }
              ]
            }
          ]
        },
        { /* AppStore 2 */
          path: 'apps2/',
          name: 'apps2',
          redirect: { name: 'apps2-home-2' },
          meta: {
            label: 'apps',
            requiresAuth: true,
            permission: permission.appStore
          },
          component: () => import(/* webpackChunkName: "appsHome2" */ './views/appstore2/AppStoreTemplate.vue'),
          children: [
            {
              path: '',
              name: 'apps2-home-2',
              meta: { label: 'home', permission: permission.appStore },
              component: () => import('./views/appstore2/Home.vue')
            },
            {
              path: 'create',
              name: 'apps2-create-2',
              meta: { label: 'Create New App', permission: permission.appStore },
              component: () => import('./views/appstore2/CreateApp.vue')
            },
            {
              path: 'createedit',
              name: 'apps2-create-edit',
              meta: { label: 'Create Edit App', permission: permission.appStore },
              props: true,
              component: () => import('./views/appstore2/SimAppForm.vue')
            },
            {
              path: ':id',
              name: 'apps2-details-2',
              redirect: { name: 'apps2-details-home-2' },
              meta: { label: 'appdetailname', permission: permission.appStore },
              component: () => import('./views/appstore2/AppStoreTemplate.vue'),
              children: [
                {
                  path: '',
                  name: 'apps2-details-home-2',
                  meta: { label: 'appdetails', permission: permission.appStore },
                  component: () => import('./views/appstore2/AppDetail.vue')
                },
                {
                  path: 'newversion',
                  name: 'apps2-version-2',
                  meta: { label: 'Add Version', permission: permission.appStore },
                  component: () => import('./views/appstore2/VersionForm.vue')
                },
                {
                  path: 'editversion/:versionid',
                  name: 'apps2-version-edit-2',
                  meta: { label: 'Edit Version', permission: permission.appStore },
                  component: () => import(/* webpackChunkName: "about" */ './views/appstore2/SimAppDetail.vue')
                },
                {
                  path: 'edit',
                  name: 'apps2-edit-2',
                  props: true,
                  meta: { label: 'Edit Application Information', permission: permission.appStore },
                  component: () => import('./views/appstore2/UpdateApp.vue')
                },
                {
                  path: 'upload',
                  name: 'apps2-upload',
                  meta: { label: 'Upload App', permission: permission.appStore },
                  component: () => import('./views/appstore2/AppUpload.vue')
                }
              ]
            }
          ]
        },
        {
          path: 'item-sharing',
          name: 'itemSharing',
          meta: {
            requiresAuth: true,
            permission: permission.itemSharing
          },
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
          path: 'messaging/',
          name: 'messaging',
          redirect: { name: 'messaging-app-list' },
          meta: {
            requiresAuth: true,
            permission: permission.messaging
          },
          component: () => import(/* webpackChunkName: "messaging" */ './views/messaging/MessagingTemplate.vue'),
          children: [
            {
              path: 'index',
              name: 'messaging-home',
              meta: {
                label: 'summary',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "messagingHome" */ './views/messaging/Home.vue')
            },
            {
              path: 'new',
              name: 'messaging-new',
              meta: {
                label: 'new',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "messagingNew" */ './views/messaging/NewMessage.vue')
            },
            {
              path: 'applist',
              name: 'messaging-app-list',
              meta: {
                label: 'app-list',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "AppList" */ './views/messaging/AppList.vue')
            },
            {
              path: 'createapp',
              name: 'messaging-create-app',
              meta: {
                label: 'create-app',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "messagingNew" */ './views/messaging/AppForm.vue')
            },
            {
              path: 'app/edit/:id',
              name: 'messaging-edit-app',
              meta: {
                label: 'edit-app',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "messagingNew" */ './views/messaging/AppForm.vue')
            },
            {
              path: 'history',
              name: 'messaging-history',
              meta: {
                label: 'history',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "messagingNew" */ './views/messaging/History.vue')
            },
            {
              path: 'usertoken',
              name: 'messaging-user-token',
              meta: {
                label: 'user-token',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "messagingNew" */ './views/messaging/UserToken.vue')
            },
            {
              path: 'usertoken/create',
              name: 'messaging-create-user-token',
              meta: {
                label: 'create-user-token',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "messagingNew" */ './views/messaging/CreateToken.vue')
            },
            {
              path: 'app/ios-provider/:id',
              name: 'messaging-app-ios-provider',
              meta: {
                label: 'ios-provider',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "messagingNew" */ './views/messaging/IOSProvider.vue')
            },
            {
              path: 'app/android-provider/:id',
              name: 'messaging-app-android-provider',
              meta: {
                label: 'android-provider',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "messagingNew" */ './views/messaging/AndroidProvider.vue')
            },
            {
              path: 'apikey',
              name: 'messaging-api-key',
              meta: {
                label: 'apikeys',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "apikeyIndex" */ './views/messaging/ApiKey.vue')
            },
            {
              path: 'apikey/generate',
              name: 'messaging-generate-api-key',
              meta: {
                label: 'apikeys',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "apikeyIndex" */ './views/messaging/ApiKeyForm.vue')
            },
            {
              path: 'apikey/:id/changesecret/',
              name: 'messaging-change-secret',
              meta: {
                label: 'apikeys',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "apikeyIndex" */ './views/messaging/ChangeSecretKey.vue')
            },
            {
              path: 'sendnotification/',
              name: 'messaging-send-notification',
              meta: {
                label: 'send-notification',
                permission: permission.messaging
              },
              component: () => import(/* webpackChunkName: "apikeyIndex" */ './views/messaging/SendNotification.vue')
            }
          ]
        },
        {
          path: 'jwt/',
          name: 'jwt',
          redirect: { name: 'jwt-home' },
          meta: {
            requiresAuth: true,
            permission: permission.developer,
            label: 'json web token'
          },
          component: () => import(/* webpackChunkName: "jwt" */ './views/jwt/JwtTemplate.vue'),
          children: [
            {
              path: 'home',
              name: 'jwt-home',
              meta: {
                label: 'home',
                permission: permission.developer
              },
              component: () => import(/* webpackChunkName: "jwtHome" */ './views/jwt/Home.vue')
            },
            {
              path: 'create',
              name: 'jwt-create',
              meta: {
                label: 'create',
                permission: permission.developer
              },
              component: () => import(/* webpackChunkName: "jwtCreate" */ './views/jwt/JwtForm.vue')
            },
            {
              path: 'details/:id',
              name: 'jwt-details',
              meta: {
                label: 'details',
                permission: permission.developer
              },
              component: () => import(/* webpackChunkName: "jwtDetails" */ './views/jwt/JwtForm.vue')
            }
          ]
        },
        {
          path: 'users/',
          name: 'userManagement',
          redirect: { name: 'userManagement-home' },
          meta: {
            requiresAuth: true,
            permission: permission.userManagement,
            label: 'users'
          },
          component: () => import(/* webpackChunkName: "about" */ './views/users/UsersTemplate.vue'),
          children: [
            {
              path: 'home',
              name: 'userManagement-home',
              meta: {
                label: 'home',
                permission: permission.userManagement
              },
              component: () => import(/* webpackChunkName: "about" */ './views/users/Home.vue')
            },
            {
              path: 'create',
              name: 'userManagement-create',
              meta: {
                label: 'create',
                permission: permission.userManagement
              },
              component: () => import(/* webpackChunkName: "about" */ './views/users/FormUser.vue')
            },
            {
              path: 'details/:username',
              name: 'userManagement-details',
              meta: {
                label: 'details',
                permission: permission.userManagement
              },
              component: () => import(/* webpackChunkName: "about" */ './views/users/FormUser.vue')
            },
            {
              path: 'profile/:username',
              name: 'userManagement-profile',
              meta: {
                label: 'profile'
              },
              component: () => import(/* webpackChunkName: "about" */ './views/users/Profile.vue')
            },
            {
              path: 'permission',
              name: 'userManagement-permission',
              meta: {
                permission: permission.userManagement,
                label: 'permission'
              },
              component: () => import(/* webpackChunkName: "about" */ './views/users/FormPermission.vue')
            },
            {
              path: 'history',
              name: 'userManagement-history',
              meta: {
                label: 'history',
                permission: permission.userManagement
              },
              component: () => import(/* webpackChunkName: "about" */ './views/users/History.vue')
            }
          ]
        },
        {
          path: 'food-delivery',
          name: 'foodDelivery',
          meta: {
            requiresAuth: true,
            permission: permission.foodDelivery
          },
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        }
      ]
    },
    {
      path: '/*',
      name: '404',
      component: () => import(/* webpackChunkName: "404" */ './views/404.vue')
    }
    /** "*" route must be defined at the end.
     * Ref: https://github.com/vuejs/vue-router/issues/2668
     * **/
  ]
});

router.beforeEach((to, from, next) => {
  const jwt = sessionStorage.getItem('jwt')
    ? sessionStorage.getItem('jwt') : localStorage.getItem('jwt')
      ? localStorage.getItem('jwt') : null;

  // set global header
  axios.defaults.headers = {
    Authorization: 'Bearer ' + jwt
  };

  if (jwt) { // handle expire!
    const decoded = jsonwebtoken.decode(jwt);
    const expireTime = decoded.exp;
    const currentTime = Math.floor((new Date()).getTime() / 1000);
    if (expireTime <= currentTime) {
      const name = to.name;
      localStorage.clear();
      sessionStorage.clear();
      store.dispatch('clearAll', true);
      return next({ name: 'login', params: { nextUrl: name } });
    }
  }

  // prevent login page after sign in already.
  if ('login' === to.name && jwt) {
    return next({ name: 'home' });
  }

  // require authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!jwt) {
      return next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      });
    } else {
      let user = JSON.parse(localStorage.getItem('user') ? localStorage.getItem('user') : sessionStorage.getItem('user'));
      const permission = to.meta.permission;

      // check permission
      if (permission && -1 === user.permission.indexOf(permission)) {
        return next({ name: 'accessDenied' });
      } else {
        return next();
      }
    }
  }
  next();
});

export default router;
